<template>
  <div>
    <table class="w-100 myMarqueeLeft">
      <tr>
        <td class="info-icon">
          <div>
              <font-awesome-icon icon="info-circle" />
          </div>
        </td>
        <td width="5"></td>
        <td>
          <div class="my-outbox">
              <div class="my-inbox" ref='box'>
                  <div class="my-list" v-for="(item,index) in sendVal" :key='index' ref='list'>
                      <span class="my-uname" :style='"color:"+item.color'>{{item.name}}</span>
                  </div>
              </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
 
<script>
export default {
  name:'my-marquee-left',
  props:{
    sendVal : {
      type: Array,
    },
  },
  data() {
    return {
      nowTime:null,
      disArr:[],
    };
  },
  mounted(){
    var item = this.$refs.list;
    var len = this.sendVal.length;
    var arr = [];
    var margin = this.getMargin(item[0]);
    for(var i = 0;i < len;i++){
      arr.push(item[i].clientWidth + margin);
    }
    this.disArr = arr;
    this.moveLeft();
  },
  beforeDestroy(){
    clearInterval(this.nowTime);
    this.nowTime = null;
  },
  methods:{
    getMargin(obj){
      var marg = window.getComputedStyle(obj,null)['margin-right'];
      marg = marg.replace('px','');
      return Number(marg);
    },
    moveLeft(){
      var outbox = this.$refs.box;
      var that=this;
      var startDis = 0;
      this.nowTime = setInterval(function(){
        startDis -= 0.5;
        if(Math.abs(startDis) > Math.abs(that.disArr[0])){
          that.disArr.push(that.disArr.shift());
          that.sendVal.push(that.sendVal.shift());
          startDis = 0;
        }
        outbox.style = 'transform: translateX('+ startDis +'px)';
        that.$forceUpdate();
      },1000/60);
    },
  },
};
</script>

<style scoped>
.myMarqueeLeft{
  color:#000000;
  background: #dcdcdc66;
  position: relative;
}
.myMarqueeLeft .info-icon{
  padding: 5px 5px 5px 5px; 
  width: 50px; 
  display: flex; 
  justify-content: center; 
  align-items: center !important;
}
.myMarqueeLeft .my-outbox{
  overflow: hidden;
  height: 35px;
}
.myMarqueeLeft .my-outbox .my-inbox{
  white-space: nowrap;
}
.myMarqueeLeft .my-outbox .my-list{
  margin-right: 25px;
  display: inline-block;
  font-size: 13px;
  height: 35px;
  line-height: 35px;
}
</style>